import styled, {css} from 'styled-components';

const Container = css`
  padding-left: 19px;
`;

export const Wrapper = styled.div`
  padding: 16px 30px;
  border-top: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;

export const Several = styled.div`
  ${Container};
`;

export const Answers = styled.div`
  margin: 14px 0;
`;

export const PushButton = styled.div`
  ${Container};
`;
